import { render, staticRenderFns } from "./BookedAppointmentCard.vue?vue&type=template&id=4bd711be&scoped=true&"
import script from "./BookedAppointmentCard.vue?vue&type=script&lang=js&"
export * from "./BookedAppointmentCard.vue?vue&type=script&lang=js&"
import style0 from "./BookedAppointmentCard.vue?vue&type=style&index=0&id=4bd711be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd711be",
  null
  
)

export default component.exports